/* Gemeinsame Scroll-Grundlage fuer Hero und Startseite.
 *
 * Lenis wird hier EINMAL erzeugt und ueber window.FLAVRBLOOM.lenis geteilt.
 * Vorher lag die Instanz in js/hero.js; die Seite darunter hatte damit keinen
 * Zugriff, und zwei Instanzen haetten sich gegenseitig die Scrollposition
 * weggeschrieben.
 */
(function () {
  'use strict';

  if (!window.gsap || !window.ScrollTrigger) return;
  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;

  gsap.registerPlugin(ScrollTrigger, window.Observer);

  /* Safari auf dem iPhone aendert die Fensterhoehe, sobald die Adressleiste
     ein- oder ausfaehrt. Ohne das hier wuerde ScrollTrigger dabei jedes Mal
     neu rechnen und die gepinnte Szene springen. */
  ScrollTrigger.config({ ignoreMobileResize: true });

  var F = window.FLAVRBLOOM = window.FLAVRBLOOM || {};
  F.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  F.istTouch = window.matchMedia('(pointer: coarse)').matches;

  /* Lenis glaettet das Mausrad auf der ganzen Seite. Auf Touch bewusst nicht:
     dort fuehlt sich der native Impuls besser an, und Lenis kaeme dem
     Gummiband-Effekt von iOS in die Quere. */
  /* 29.10.2026 (Kevin in Safari am PC: „ruckelt und bleibt hängen, bevor man die Karte verlässt“): Auf der Bloomia-Seite
     mit der Tür scrollt der Browser selbst. Mit Lenis lief das Scrollen über ein Skript, und jeder kurze Rechenschritt an
     der Karte hielt die ganze Seite an. */
  var ohneLenis = F.istTouch || F.reduce.matches ||
                  /[?&]nolenis\b/.test(location.search) ||
                  !!document.querySelector('.kino') ||
                  /* 29.10.2026: in Safari überall aus. Dort hielt Lenis bei jeder kurzen Rechenpause die ganze Seite an
                     (Kevin in Safari am PC); ohne Lenis scrollt Safari mit seinem eigenen weichen Lauf. */
                  /^((?!chrome|chromium|crios|fxios|edg|android).)*safari/i.test(navigator.userAgent);

  F.lenis = null;
  if (window.Lenis && !ohneLenis) {
    F.lenis = new window.Lenis({
      /* lerp statt duration: `duration` gibt jedem Scrollimpuls eine feste
         Laufzeit - bei schnellen Rasten hintereinander stapeln sich die
         Laeufe und die Seite rutscht nach. `lerp` naehert sich jeden Frame um
         einen festen Anteil an, das bleibt auch bei schnellem Radeln ruhig.
         0,09 ist weich, ohne zaeh zu werden.

         wheelMultiplier 0,85: eine Raste liefert in Chrome rund 120 px, das
         ist fuer diese Seite zu viel. Gemessener Weg pro Raste danach:
         siehe scripts/pruefung/rad.mjs.

         KEIN Snap, nirgends - weder hier noch als ScrollTrigger-Option. */
      lerp: 0.09,
      wheelMultiplier: 0.85,
      smoothWheel: true,
      syncTouch: false,
      touchMultiplier: 1
    });
    F.lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (zeit) { F.lenis.raf(zeit * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  /* Ein gemeinsames Nachmessen, wenn wirklich alles steht.
     hero.js und seite.js bauen schon auf document.fonts.ready auf, damit die
     Seite frueh bedienbar ist. Bis window load koennen sich die Hoehen aber
     noch aendern (Bilder, spaet nachgeladene Schnitte). ScrollTrigger rechnet
     dann mit veralteten Abstaenden - genau davon leben abgeschnittene Enden
     und verrutschte Pins. Also: bauen wie bisher, danach einmal sauber
     nachmessen, und Lenis die neue Dokumenthoehe mitteilen. */
  var geladen = document.readyState === 'complete'
    ? Promise.resolve()
    : new Promise(function (fertig) {
        window.addEventListener('load', fertig, { once: true });
      });
  var schriften = (document.fonts && document.fonts.ready)
    ? document.fonts.ready
    : Promise.resolve();

  F.bereit = Promise.all([geladen, schriften]);

  F.bereit.then(function () {
    requestAnimationFrame(function () {
      /* seite.js haengt hier das Neusetzen von Footer-Platzhalter und
         Ueberlappung ein - das muss VOR dem refresh passieren. */
      if (F.nachMessen) F.nachMessen();
      else ScrollTrigger.refresh();
      if (F.lenis) F.lenis.resize();
    });
  });

  /* Einheitlicher Weg, irgendwohin zu springen - egal ob Lenis laeuft. */
  F.scrollZu = function (y, dauer) {
    if (F.lenis) F.lenis.scrollTo(y, { duration: dauer || 0.8 });
    else window.scrollTo({ top: y, behavior: 'smooth' });
  };
})();
